import React from 'react';
import { Button } from 'components/elements';
import { Form, FormDrawer, InputField, SelectField } from 'components/form';
import PropTypes from 'prop-types';

import { useUpdatePosition } from '../api/updatePosition';

export const UpdatePosition = ({
  avg_price,
  quantity,
  price_target,
  action,
  ticker,
  pk,
}) => {
  const updatePositionMutation = useUpdatePosition();

  return (
    <>
      <FormDrawer
        size="sm"
        isDone={updatePositionMutation.isSuccess}
        triggerButton={
          <button className="flex items-start m-2 mx-4">
            <span className="flex">
              Update <span className="hidden md:flex mx-2">position</span>
            </span>
          </button>
        }
        title={`Update ${ticker} position`}
        submitButton={
          <Button
            form="update-trade-position"
            type="submit"
            size="sm"
            isLoading={updatePositionMutation.isLoading}
          >
            Submit
          </Button>
        }
      >
        <Form
          id="update-trade-position"
          onSubmit={async values => {
            values.pk = pk;
            await updatePositionMutation.mutateAsync({
              data: values,
            });
          }}
          options={{
            defaultValues: {
              avg_price,
              quantity,
              price_target,
              action,
            },
          }}
        >
          {({ register, formState }) => (
            <>
              <InputField
                label="Cost Basis"
                type="number"
                step="any"
                error={formState.errors['avg_price']}
                registration={register('avg_price')}
              />
              <InputField
                label="Quantity"
                type="number"
                error={formState.errors['quantity']}
                registration={register('quantity')}
              />
              <SelectField
                label="Action"
                error={formState.errors['action']}
                registration={register('action')}
                options={[
                  { value: 'buy', label: 'Buy' },
                  { value: 'sell', label: 'Sell' },
                ]}
              />
            </>
          )}
        </Form>
      </FormDrawer>
    </>
  );
};

UpdatePosition.propTypes = {
  avg_price: PropTypes.number,
  quantity: PropTypes.number,
  price_target: PropTypes.number,
  // action: PropTypes.string.isRequired,
};
